enum RouteEndpointsItems {
  BASE_ITEMS = '/item-list',
  EDIT_ITEM = 'edit/:id',
  ADD_ITEM = 'add',
}

export default RouteEndpointsItems;
